/*
 * Project: bellcloud
 * File: theme/tokens/breakpoints.ts
 * Description: 반응형 breakpoint 정의 및 미디어 쿼리 헬퍼
 */

import { css } from '@emotion/react';

export const breakpoints = {
  xs: 480,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
} as const;

// 반응형 미디어 쿼리 헬퍼
// min-width: 해당 breakpoint 이상, max-width: 해당 breakpoint 미만 (breakpoint - 1)
export const media = {
  // min-width (모바일 우선)
  xs: (styles: TemplateStringsArray | string) => css`
    @media (min-width: ${breakpoints.xs}px) {
      ${styles}
    }
  `,
  sm: (styles: TemplateStringsArray | string) => css`
    @media (min-width: ${breakpoints.sm}px) {
      ${styles}
    }
  `,
  md: (styles: TemplateStringsArray | string) => css`
    @media (min-width: ${breakpoints.md}px) {
      ${styles}
    }
  `,
  lg: (styles: TemplateStringsArray | string) => css`
    @media (min-width: ${breakpoints.lg}px) {
      ${styles}
    }
  `,
  xl: (styles: TemplateStringsArray | string) => css`
    @media (min-width: ${breakpoints.xl}px) {
      ${styles}
    }
  `,
  '2xl': (styles: TemplateStringsArray | string) => css`
    @media (min-width: ${breakpoints['2xl']}px) {
      ${styles}
    }
  `,

  // max-width (데스크탑 우선, breakpoint - 1 으로 min-width와 겹치지 않음)
  maxXs: (styles: TemplateStringsArray | string) => css`
    @media (max-width: ${breakpoints.xs - 1}px) {
      ${styles}
    }
  `,
  maxSm: (styles: TemplateStringsArray | string) => css`
    @media (max-width: ${breakpoints.sm - 1}px) {
      ${styles}
    }
  `,
  maxMd: (styles: TemplateStringsArray | string) => css`
    @media (max-width: ${breakpoints.md - 1}px) {
      ${styles}
    }
  `,
  maxLg: (styles: TemplateStringsArray | string) => css`
    @media (max-width: ${breakpoints.lg - 1}px) {
      ${styles}
    }
  `,
  maxXl: (styles: TemplateStringsArray | string) => css`
    @media (max-width: ${breakpoints.xl - 1}px) {
      ${styles}
    }
  `,
  max2xl: (styles: TemplateStringsArray | string) => css`
    @media (max-width: ${breakpoints['2xl'] - 1}px) {
      ${styles}
    }
  `,
};
